import identity from "lodash/fp/identity";

class PrivateBusRequestPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    return identity(data);
  }
}

export default PrivateBusRequestPageTransform;



// WEBPACK FOOTER //
// ./src/pages/privateBusRequest/privateBusRequest.transforms.js